var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll"
        }
      ],
      staticClass: "scrollable_area blubber_thread_widget"
    },
    [
      _c(
        "transition-group",
        {
          attrs: {
            name: "blubberthreadwidget-list",
            tag: "ol"
          }
        },
        [
          _vm._l(_vm.sortedThreads, function(thread) {
            return _c(
              "li",
              {
                key: thread.thread_id,
                class:
                  (_vm.active_thread === thread.thread_id ? "active" : "") +
                  (thread.unseen_comments > 0 ? " unseen" : ""),
                attrs: {
                  "data-thread_id": thread.thread_id,
                  "data-unseen_comments": thread.unseen_comments
                },
                on: {
                  click: function click($event) {
                    $event.preventDefault()
                    return _vm.changeActiveThread($event)
                  }
                }
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.link(thread.thread_id)
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "avatar",
                      style: {
                        backgroundImage: "url(" + thread.avatar + ")"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "info"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "name"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(thread.name) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("studip-date-time", {
                          attrs: {
                            timestamp: thread.timestamp,
                            relative: true
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.display_more_down
            ? _c(
                "li",
                {
                  key: "more",
                  staticClass: "more"
                },
                [
                  _c("studip-asset-img", {
                    attrs: {
                      file: "ajax-indicator-black.svg",
                      width: "20"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }